import React from 'react'
import { connect } from 'react-redux'
import pure from 'recompose/pure'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import CTAButton from './CTAButton'
import { beginRegistrationFromCTA } from './../ctaPromptActions'
import ActionButton from 'aria-viewer/tour/components/buttons/actionButton'

const S = {
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    actionButtonMobile: {
        height: '56px',
        boxSizing: 'border-box',
        margin: '24px 34px',
        cursor: 'pointer',
    },
    actionButtonDesktop: {
        maxWidth: '210px',
        margin: '5px',
        cursor: 'pointer',
        width: '62vw',
        padding: '13.5px 0px',
    },
    actionButtonMobileLabel: {
        textTransform: 'uppercase',
        fontSize: '16px',
        fontWeight: 500,
        margin: 'auto',
        paddingTop: '18px',
    },
    actionButtonDesktopLabel: {
        fontSize: '0.9em',
        fontWeight: 400,
    },
}

const CTAButtons = pure(function ActionButtons({
    isRegistrationEnabled,
    registrationActionButtons,
    actionButtons,
    beginRegistrationFromCTA,
    ctaPromptIsModal,
    exitCTAPromptLogic,
    className,
    isDeviceMobile,
}) {
    const actions = isRegistrationEnabled ? registrationActionButtons : actionButtons.get('actions')

    const onClickRegisterNow = () => {
        exitCTAPromptLogic && exitCTAPromptLogic() // in case we need some
        // custom close logic; e.g. for "What's Next"
        // legacy code
        beginRegistrationFromCTA({ ctaPromptIsModal })
    }

    return (
        actions.length > 0 && (
            <div style={isDeviceMobile ? null : S.buttonContainer}>
                {actions.map((item, index) => (
                    <ActionButton
                        index={index}
                        onClick={item.actionid == 'register' && onClickRegisterNow}
                        action={item}
                        className={className || ''}
                        key={`actionButton_${index}`}
                        style={isDeviceMobile ? S.actionButtonMobile : S.actionButtonDesktop}
                        labelStyle={isDeviceMobile ? S.actionButtonMobileLabel : S.actionButtonDesktopLabel}
                    >
                        {item.name}
                    </ActionButton>
                ))}
            </div>
        )
    )
})

export default connect(
    mapSelectorsToProps(['isRegistrationEnabled', 'actionButtons', 'registrationActionButtons']),
    { beginRegistrationFromCTA }
)(CTAButtons)
